import LabelForm from './LabelForm'

export default LabelForm
